document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-breaks').forEach(initDailyChews);
});

// Mapping: for each variant, which selling plan corresponds to each
// quantity-break option. Keyed by REAL PACKS shipped (1 / 4 / 6).
const DAILY_CHEWS_PLAN_MAP = {
  58268963045707: { 1: 724410958155, 4: 724410990923, 6: 724411023691 }, // TearCalm
};

// Cart quantity -> real packs shipped. Quantity radios already use 1/4/6,
// so unmapped values fall back to the quantity itself.
const QTY_TO_PACKS = { 1: 1, 2: 4, 3: 6 };

function initDailyChews(container) {
  const sectionId = container.dataset.section;

  const dailyChewsScript = document.querySelector(`[data-daily-chews="${sectionId}"]`);
  const variantsScript = container.querySelector('script[data-has-variants]');
  if (!dailyChewsScript || !variantsScript) return;

  const dailyChewsMap = JSON.parse(dailyChewsScript.textContent);
  const variants = JSON.parse(variantsScript.textContent);

  function getHiddenIdInput() {
    return (
      document.querySelector(`#product-form-${sectionId} input[name="id"]`) ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]')
    );
  }

  function getSubscriptionBox() {
    return document.querySelector('.subscription__box--subscription');
  }

  function getSelectedVariant() {
    const input = getHiddenIdInput();
    const id = input ? Number(input.value) : variants[0].id;
    return variants.find((v) => v.id === id) || variants[0];
  }

  function isSubscriptionSelected() {
    const box = getSubscriptionBox();
    return box ? box.dataset.selected === 'true' : false;
  }

  function getSelectedQty() {
    const checked = container.querySelector('input[name="quantity"]:checked');
    return checked ? Number(checked.value) : null;
  }

  // Replaces [token] occurrences inside text nodes only, leaving any markup
  // (e.g. <strong>) inside the element untouched.
  function replaceTokensInElement(el, tokenValues) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach((textNode) => {
      let text = textNode.nodeValue;
      let changed = false;
      Object.entries(tokenValues).forEach(([token, value]) => {
        if (text.includes(token)) {
          text = text.split(token).join(value);
          changed = true;
        }
      });
      if (changed) textNode.nodeValue = text;
    });
  }

  // Sale price element of a quantity break: a leaf element containing only a
  // price, and not struck through (that one is the compare-at price).
  function isStruck(el) {
    if (el.closest('s, del, strike')) return true;
    for (let n = el; n && n !== document.body; n = n.parentElement) {
      if ((getComputedStyle(n).textDecorationLine || '').includes('line-through')) return true;
    }
    return false;
  }
  function findSalePriceEl(breakEl) {
    return Array.from(breakEl.querySelectorAll('*')).find(
      (el) =>
        el.children.length === 0 &&
        /^\s*[$£€]\s?[\d.,]+\s*$/.test(el.textContent) &&
        !isStruck(el)
    );
  }
  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  // Hide the manual frequency picker — it's driven automatically.
  function hideFrequencyPicker() {
    document.querySelectorAll('.subscription__frequency').forEach((el) => {
      el.style.display = 'none';
    });
  }

  // The subscription widget doesn't re-render its own fields when the
  // quantity-break offer changes. Snapshot each element's original template
  // ONCE, then always regenerate from that pristine copy on every poll.
  const pristineTemplates = new WeakMap();
  function applyTokensFromPristine(el, tokenValues) {
    if (!pristineTemplates.has(el)) pristineTemplates.set(el, el.innerHTML);
    let html = pristineTemplates.get(el);
    Object.entries(tokenValues).forEach(([token, value]) => {
      html = html.split(token).join(value);
    });
    el.innerHTML = html;
  }

  function syncSellingPlan() {
    if (!isSubscriptionSelected()) return;

    const variant = getSelectedVariant();
    const qty = getSelectedQty();
    if (!qty) return;

    const packs = QTY_TO_PACKS[qty] || qty;
    const planId = DAILY_CHEWS_PLAN_MAP[variant.id] && DAILY_CHEWS_PLAN_MAP[variant.id][packs];
    if (!planId) return;

    // Radio found by plan ID only, whatever its name attribute is.
    // Real click so the theme's own handlers run.
    const radio = document.querySelector(`input[type="radio"][value="${planId}"]`);
    if (radio && !radio.checked) radio.click();

    // Dropdown-style picker, if any.
    document.querySelectorAll('select').forEach((select) => {
      const hasOption = Array.from(select.options).some((o) => o.value === String(planId));
      if (hasOption && select.value !== String(planId)) {
        select.value = String(planId);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Make sure the value actually sent to the cart matches.
    document
      .querySelectorAll('form[action*="/cart/add"] input[name="selling_plan"]')
      .forEach((input) => {
        if (input.value !== String(planId)) {
          input.value = String(planId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
  }

  function update() {
    const variant = getSelectedVariant();
    const dailyChew = Number(dailyChewsMap[variant.id]) || 1;
    const subscriptionActive = isSubscriptionSelected();
    const breakPrices = {};

    container.querySelectorAll('.quantity-break').forEach((breakEl) => {
      const qty = Number(breakEl.dataset.quantity);
      const percentageLeft = Number(breakEl.dataset.percentageLeft);
      const fixedDiscount = Number(breakEl.dataset.fixedDiscount);
      const totalChews = Number(breakEl.dataset.totalChews);
      if (!qty || !totalChews) return;

      const daysSupply = Math.round(totalChews / dailyChew);
      let priceCents = variant.price * qty * percentageLeft - fixedDiscount;
      if (subscriptionActive) priceCents *= 0.85;
      const pricePerDay = priceCents / daysSupply / 100;
      const priceLabel = `$${(priceCents / 100).toFixed(2)}`;
      breakPrices[qty] = priceLabel;

      // Overwrite Shrine's displayed price, which stacks the selling-plan
      // discount on top of the quantity-break discount.
      setText(findSalePriceEl(breakEl), priceLabel);

      breakEl.querySelectorAll('[data-text]').forEach((el) => {
        replaceTokensInElement(el, {
          '[days_supply]': `${daysSupply} day supply`,
          '[price_per_day]': `$${pricePerDay.toFixed(2)} per day`,
        });
      });
    });

    // Subscription widget: only one offer is "active" at a time.
    const selectedQty = getSelectedQty();
    if (selectedQty) {
      const selectedBreak = container.querySelector(`.quantity-break[data-quantity="${selectedQty}"]`);
      const selectedTotalChews = selectedBreak ? Number(selectedBreak.dataset.totalChews) : null;

      if (selectedTotalChews) {
        const selectedDaysSupply = Math.round(selectedTotalChews / dailyChew);
        const widget = document.querySelector(`#SubscriptionWidget-${sectionId}`);

        if (widget) {
          const tokens = { '[days_supply]': `${selectedDaysSupply} days` };

          widget.querySelectorAll('[data-text]').forEach((el) => {
            applyTokensFromPristine(el, tokens);
          });
          const benefits = widget.querySelector('.subscription__benefits');
          if (benefits) applyTokensFromPristine(benefits, tokens);
        }
      }
    }

    // Add-to-cart button: show the selected break's real price.
    if (selectedQty && breakPrices[selectedQty]) {
      document
        .querySelectorAll('form[action*="/cart/add"] [type="submit"]')
        .forEach((btn) => {
          const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (/[$£€]\s?[\d.,]+/.test(node.nodeValue)) {
              const next = node.nodeValue.replace(/[$£€]\s?[\d.,]+/, breakPrices[selectedQty]);
              if (next !== node.nodeValue) node.nodeValue = next;
            }
          }
        });
    }

    syncSellingPlan();
  }

  container.querySelectorAll('input[name="quantity"]').forEach((input) => {
    input.addEventListener('change', update);
  });

  function poll() {
    hideFrequencyPicker();
    update();
  }

  hideFrequencyPicker();
  setInterval(poll, 100);
  update();
}